import { Button } from '../Utility/Button';
import Input from '../Utility/FormElements/Input';
import useUserAssistans from '../../Hooks/useUserAssistans';
import { Prompt } from '../../Types';
import LoadingSpinner from '../Utility/LoadingSpinner';
import UserPromptCard from '../Utility/UserPromptCard';

function Assistants() {
    const { UserAssistansActions, i18n, handleNavigate, prompts, filteredAssistants, assistantsLoaded, filter, models } =
        useUserAssistans();

    return (
        <div className={`admin-container flex relative flex-col`}>
            <div className="mt-10 px-10 pt-[70px] md:pt-[100px]">
                <div className="grid grid-cols-12 gap-x-4 mb-4 md:mb-10 ">
                    <div className="col-span-12 sm:col-span-12 md:col-span-4 lg:col-span-4 2xl:col-span-3">
                        <Input
                            value={filter}
                            placeholder={i18n.translate({
                                id: 'filter.placeholder',
                                sourceName: 'Main',
                            })}
                            onChange={(value) => UserAssistansActions.handleFilterChange(value)}
                            classList=""
                        />
                    </div>
                    {models.length > 0 && (
                        <div className="col-span-12 sm:col-span-12 md:col-span-8 lg:col-span-8 2xl:col-span-9 flex justify-end items-center">
                            <Button onClick={() => handleNavigate('new')} className="w-full mt-3 md:w-auto md:mt-0">
                                {i18n.translate({
                                    id: 'newAssistant.button',
                                    sourceName: 'Assistants',
                                })}
                            </Button>
                        </div>
                    )}
                </div>

                <div className="grid grid-cols-12 gap-4 mb-4">
                    {assistantsLoaded ? (
                        prompts.length > 0 ? (
                            filteredAssistants.length > 0 ? (
                                filteredAssistants.map((prompt: Prompt) => (
                                    <UserPromptCard
                                        key={prompt.identifier}
                                        createNewChat={UserAssistansActions.createNewChat}
                                        handleRemoveProposedGlobal={UserAssistansActions.handleRemoveProposedGlobal}
                                        handleProposeGlobal={UserAssistansActions.handleProposeGlobal}
                                        handleDelete={UserAssistansActions.handleDelete}
                                        handleEdit={handleNavigate}
                                        prompt={prompt}
                                    />
                                ))
                            ) : (
                                filter !== '' && (
                                    <div className="flex justify-center items-center h-10 col-span-12">
                                        <span className="text-center">
                                            {filter !== '' && (
                                                <span>
                                                    {i18n.translate({
                                                        id: 'filter.notFound',
                                                        sourceName: 'Assistants',
                                                    })}
                                                    <span className="font-semi-bold"> "{filter}"</span>
                                                </span>
                                            )}
                                        </span>
                                    </div>
                                )
                            )
                        ) : (
                            <>
                                <div className="flex justify-center items-center h-10 col-span-12">
                                    <span className="text-center">
                                        {i18n.translate({
                                            id: 'empty',
                                            sourceName: 'Assistants',
                                        })}
                                    </span>
                                </div>
                            </>
                        )
                    ) : (
                        <div className="flex justify-center items-center h-10 col-span-12">
                            <LoadingSpinner />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Assistants;
